/**
 * observer.js
 *
 * @Author: apple
 * @Date: 2018/1/2 23:35
 */

const pubsub = {
    _private: {},
};
(function(q) {
    const topics = Object.assign({}, pubsub._private); // 回调函数存放的数组
    let subUid = -1;
    // 发布方法
    q.publish = (topic, args) => {
        if (!topics[topic]) {
            return false;
        }

        setTimeout(function() {
            const subscribers = topics[topic];
            let len = subscribers ? subscribers.length : 0;

            while (len--) {
                subscribers[len].func(topic, args);
            }
        }, 0);

        return true;
    };
    // 订阅方法
    q.subscribe = (topic, func) => {
        if (!topics[topic]) {
            topics[topic] = [];
        }

        const token = (++subUid).toString();
        topics[topic].push({
            token,
            func,
        });
        return token;
    };
    // 退订方法
    q.unsubscribe = token => {
        for (const m in topics) {
            if (topics[m]) {
                for (let i = 0, j = topics[m].length; i < j; i++) {
                    if (topics[m][i].token === token) {
                        topics[m].splice(i, 1);
                        return token;
                    }
                }
            }
        }
        return false;
    };
})(pubsub);

export default pubsub;



// WEBPACK FOOTER //
// ./src/util/observer.js